module.exports = __webpack_public_path__ + "static/media/assembly_H2.ae34bea4.png";